import * as React from 'react';
import { useDispatch } from 'react-redux';
import DataColumn from '../../components/controls/datagrid/DataColumn';
import DataList from '../../components/controls/datagrid/DataList';
import { setOperation } from '../operation/operationSlice';

export default (props: { controller: string, items: any }) => {
    const dispatch = useDispatch()
    const onRowClick = (e: any, data: any) => {
        e.preventDefault()
        dispatch(setOperation("read", props.controller, { index: data }))
    }

    return (
        <>
            <DataList items={props.items} onRowClick={onRowClick} >
                <DataColumn kid='column1' name='Descrizione' fieldName='description' minWidth={250} align='left' />
                <DataColumn kid='column2' name='Data inserimento' fieldName='insertionDate' minWidth={200} maxWidth={250} align='center' />
                <DataColumn kid='column3' name='Tipo di documento' fieldName='leap_PrivacyDocumentTypeID' minWidth={200} maxWidth={250} align='left' />
            </DataList>
        </>
    );
}
